import { Col, ColProps } from "@p0security/ui";
import classNames from "classnames";

/** A scrolling, outlined panel holding the cloud provider choices. */
export const StyledCloudContainer: React.FC<React.PropsWithChildren> = ({
  children,
}) => (
  <div className="max-h-[600px] overflow-auto rounded-md border-2 border-solid border-[#69c0ff] p-[10px]">
    {children}
  </div>
);

/** A column whose card lets its title wrap and stacks its body contents. */
export const StyledCol: React.FC<ColProps> = ({ className, ...props }) => (
  <Col
    className={classNames(
      "[&_.ant-card-head-title]:[text-overflow:initial]! [&_.ant-card-head-title]:whitespace-normal! [&_.ant-card-body]:flex! [&_.ant-card-body]:flex-col! [&_.ant-card-body]:items-center!",
      className
    )}
    {...props}
  />
);
